import { useMemo } from "react";

import {
    IngredientDataType,
    IngredientType,
} from "../config/enums/IngredientType.enum";

type IngredientFlags = {
    processIngredient: boolean;
    produceIngredient: boolean;
    enableIngredient: boolean;
    lcaIngredient: boolean;
};


export const useIngredientFlags = (
    ingredientType: IngredientType | undefined,
    dataType: IngredientDataType | undefined
): IngredientFlags => {
    return useMemo(() => {
        const conditionMap: Record<string, IngredientFlags> = {
            [`${IngredientType.PROCESSED}_${IngredientDataType.GENERIC}`]: {
                processIngredient: true,
                produceIngredient: false,
                enableIngredient: false,
                lcaIngredient: false,
            },
            [`${IngredientType.RAW}_${IngredientDataType.GENERIC}`]: {
                processIngredient: false,
                produceIngredient: true,
                enableIngredient: true,
                lcaIngredient: false,
            },
            [`${IngredientType.RAW || IngredientType.PROCESSED}_${IngredientDataType.CALCULATED_LCA}`]: {
                processIngredient: false,
                produceIngredient: false,
                enableIngredient: false,
                lcaIngredient: true,
            },
        };

        const key = `${ingredientType}_${dataType}`;
        return conditionMap[key] ?? {
            processIngredient: false,
            produceIngredient: false,
            enableIngredient: false,
            lcaIngredient: false,
        };
    }, [ingredientType, dataType]);
};
